<template>
  <div id="questionDiv" class="question-screen" v-if="showQuestion">

    <!-- QUESTION CARD -->
    <div class="question-card">
      <p class="question rtl">
        {{ questionsArray[firstQuestion].question }}
      </p>
    </div>

    <!-- ANSWER BUTTONS -->
    <div class="answers-wrapper rtl">
      <div :key="answer.id" v-for="answer in getAnswerArray">
        <button class="answer-btn fullWidth" :disabled="answered" @click="checkAnswer(answer, $event)">
          {{ answer }}
        </button>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      // firstQuestion: 1,
      firstQuestion: 0,
      answered: false,
      audio: new Audio(this.soundToPlay),
      soundToPlay: "",
      questionNumber: 0,
      correctAnswerSound: require("../../static/sounds/correctAnswer.mp3"),
      wongAnswerSound: require("../../static/sounds/wrongAnswer.mp3"),
      // errorNumber: 0,
      showLastDialog: false,
      endTime: "",
      questionForSpecificPoint: "",
    };
  },
  mounted() {

    if (localStorage.getItem("firstQuestion")) {
      this.firstQuestion = JSON.parse(localStorage.getItem("firstQuestion"));
    }
    localStorage.setItem("questionNumber", this.$parent.questionNumber);
    if (localStorage.getItem("questionForSpecificPoint")) {
      this.questionForSpecificPoint = JSON.parse(
        localStorage.getItem("questionForSpecificPoint")
      );
    }
    // this.$parent.showMultipleMatch = false;
    // this.$parent.showPuzzle = false;
  },
  computed: {
    showQuestion() {
      //  if (this.$parent.showQuestion == true) {
      if (this.$parent.showQuestions == true) {

        return true;
      } else {
        return false;
      }
    },
    numberOfQUestionPerPoint() {
      return Math.floor(
        this.$store.getters.questionsShuffled.length /
        (this.$store.getters.points.length - 1)
      );
    },
    pointsArrayOrder() {
      if (localStorage.getItem("pointsArrayOrder")) {
        return JSON.parse(localStorage.getItem("pointsArrayOrder"));
      } else {
        return this.$store.getters.pointsArrayOrder;
      }
    },
    points() {
      return this.$store.getters.points;
    },
    // questionsShuffled() {
    questionsArray() {
      var parentPointNum = this.$parent.pointNum;
      //  console.log("[questionsArray] parentPointNum", parentPointNum);
      var pointArrayOrder = this.$parent.pointsArrayOrder;
      //  console.log("[questionsArray] pointArrayOrder", pointArrayOrder);

      var arrayOfQuestionForSpecificPoint = [];
      var fullArray;
      if (localStorage.getItem("questionsArray")) {
        fullArray = JSON.parse(localStorage.getItem("questionsArray"));
        //  console.log("[questionsArray] fullArray", fullArray);
      } else {
        fullArray = this.$store.getters.questionsArray;
        //  console.log("[questionsArray] fullArray", fullArray);
      }
      //// TRYING TO GET THE QUESTIONARRAY INSTEAD OF THE QUESTIONSHUFFLED
      // Si les questions ne sont pas liées aux points et doivent garder le même ordre peux importe l'ordre des points
      if (this.$store.getters.gameParameters.questionsOrder == "sorted") {

        fullArray.forEach(function (question) {
          if (question.pointLinked == JSON.stringify(parentPointNum + 1)) {
            arrayOfQuestionForSpecificPoint.push(question);
          }
        });
        // console.log(
        //   "arrayOfQuestionForSpecificPoint",
        //   arrayOfQuestionForSpecificPoint
        // );
        localStorage.setItem(
          "questionForSpecificPoint",
          JSON.stringify(arrayOfQuestionForSpecificPoint)
        );
        // this.questionForSpecificPoint = arrayOfQuestionForSpecificPoint;
        return arrayOfQuestionForSpecificPoint;
        /// Si les questions sont liées aux points spécifique
      } else if (
        this.$store.getters.gameParameters.questionsOrder ==
        "linkedToPointNumber"
      ) {
        fullArray.forEach(function (question) {
          if (
            question.pointLinked ==
            JSON.stringify(pointArrayOrder[parentPointNum])
          ) {
            arrayOfQuestionForSpecificPoint.push(question);
          }
        });
        localStorage.setItem(
          "questionForSpecificPoint",
          JSON.stringify(arrayOfQuestionForSpecificPoint)
        );
        //  this.questionForSpecificPoint = arrayOfQuestionForSpecificPoint;

        return arrayOfQuestionForSpecificPoint;

        ///************fini avec linkedToPointNumber */
      } else {
        if (localStorage.getItem("questionsArray")) {
          return JSON.parse(localStorage.getItem("questionsArray"));
        } else {
          return this.$store.getters.questionsShuffled;
        }
      }
    },
    getAnswerArray() {
      let answerArray;
      // answerArray = [
      //   this.questionsArray[this.$parent.questionNumber].wrongAnswer1,
      //   this.questionsArray[this.$parent.questionNumber].wrongAnswer2,
      //   this.questionsArray[this.$parent.questionNumber].wrongAnswer3,
      //   this.questionsArray[this.$parent.questionNumber].correctAnswer,
      // ];
      answerArray = [
        this.questionsArray[this.firstQuestion].wrongAnswer1,
        this.questionsArray[this.firstQuestion].wrongAnswer2,
        this.questionsArray[this.firstQuestion].wrongAnswer3,
        this.questionsArray[this.firstQuestion].correctAnswer,
      ];
      let currentIndex = answerArray.length,
        temporaryValue,
        randomIndex;
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = answerArray[currentIndex];
        answerArray[currentIndex] = answerArray[randomIndex];
        answerArray[randomIndex] = temporaryValue;
      }
      return answerArray;
    },
  },

  methods: {
    checkAnswer(answer, event) {
      if (this.answered) return;
      this.$parent.showMultipleMatch = false;
      this.$parent.showPuzzle = false;
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").classList.remove("fadeIn");
      } else {
        console.log("[checkAnswer] No questionDiv");
      }
      //////////////////  CORRECT ANSWER ///////////////////////////

      // if (
      //   answer ===
      //   this.questionsArray[this.$parent.questionNumber].correctAnswer
      // ) {
      if (answer === this.questionsArray[this.firstQuestion].correctAnswer) {
        this.answered = true;
        event.target.classList.add("bg-green");
        var audio = new Audio(this.correctAnswerSound);
        audio.play();
        this.$parent.errorNumber = this.$parent.errorNumber + 5;
        this.$parent.showStarUp("5+");
        this.$parent.showCorrectAnswerIcon = true;
        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        if (
          Object.values(this.points)[
            this.pointsArrayOrder[this.$parent.pointNum] - 1
          ].pointNumber == this.$parent.gameParameters.lastPoint
        ) {
          console.log("JE VAIS AU NEXTPOINT ******************");
          //this.goToNextPoint();
        }
        setTimeout(() => {
          this.firstQuestion++;
          this.answered = false;
          //  this.$parent.questionNumber++;
          this.$parent.showCorrectAnswerIcon = false;
          localStorage.setItem("questionNumber", this.$parent.questionNumber);
          // if (this.$parent.questionNumber != this.questionsArray.length) {
          this.checkForNextQuestion();
          this.getRidOfButtonColors();
          window.scrollTo(0, 0)

          // }
        }, 3000);
        // }
      } else {
        //////////////////  WRONG ANSWER //////////////////////////
        this.$parent.$refs.pointsCounting.classList.add("redColor");
        this.$parent.showWongAnswerIcon = true;

        event.target.classList.add("bg-red");
        audio = new Audio(this.wongAnswerSound);
        audio.play();
        this.$parent.errorNumber--;

        localStorage.setItem("errorNumber", this.$parent.errorNumber);
        setTimeout(() => {
          this.$parent.$refs.pointsCounting.classList.remove("redColor");
          this.$parent.showWongAnswerIcon = false;
        }, 1000);
      }
    },
    checkForNextQuestion() {
      // ***********************************************ADDED THIS JUST FOR THE RANDOM QUESTIONS
      if (this.$parent.gameParameters.randomQuestions === true) {
        if (this.firstQuestion < this.numberOfQUestionPerPoint + 1) {
          // this.$parent.questionNumber++;
          localStorage.setItem("questionNumber", this.$parent.questionNumber);
          this.firstQuestion++;
          localStorage.setItem("firstQuestion", this.firstQuestion);
        } else {
          localStorage.setItem("questionNumber", this.$parent.questionNumber);
          this.firstQuestion = 1;
          localStorage.setItem("firstQuestion", 1);
          this.goToNextPoint();
          // }
        }
      } else {
        if (
          this.$store.getters.gameParameters.questionsOrder ==
          "linkedToPointNumber" ||
          this.$store.getters.gameParameters.questionsOrder == "sorted"
        ) {
          if (this.firstQuestion < this.questionsArray.length) {
            localStorage.setItem("firstQuestion", this.firstQuestion);
          } else {
            localStorage.setItem("questionNumber", this.$parent.questionNumber);
            this.firstQuestion = 0;
            localStorage.setItem("firstQuestion", 0);
            this.goToNextPoint();
          }
        } else {
          if (
            Object.values(this.points)[
              this.pointsArrayOrder[this.$parent.pointNum] - 1
            ].pointNumber ==
            this.questionsArray[this.$parent.questionNumber].pointLinked
          ) {
            // this.$parent.questionNumber++;
            // localStorage.setItem("questionNumber", this.$parent.questionNumber);
            this.firstQuestion++;
            localStorage.setItem("firstQuestion", this.firstQuestion);
          } else {
            localStorage.setItem("questionNumber", this.$parent.questionNumber);

            this.firstQuestion = 1;
            localStorage.setItem("firstQuestion", 1);
            this.goToNextPoint();

            // }
          }
        }
      }
    },
    getRidOfButtonColors() {
      const redButton = document.querySelectorAll("button.bg-red");
      redButton.forEach((button) => {
        button.classList.remove("bg-red");
      });
      const greenButton = document.querySelectorAll("button.bg-green");
      greenButton.forEach((button) => {
        button.classList.remove("bg-green");
      });
    },
    goToNextPoint() {
      this.$parent.showPointInformation = false;
      localStorage.setItem(
        "showPointInformation",
        this.$parent.showPointInformation
      );
      this.$parent.showPickedItem = false;
      localStorage.setItem("showPickedItem", this.$parent.showPickedItem);
      this.$parent.showMainScreen = true;
      localStorage.setItem("showMainScreen", this.$parent.showMainScreen);
      this.$parent.nextPointNumber();
      window.scrollTo(0, 0)

      // localStorage.setItem("showMainScreen", this.$parent.showMainScree);
    },
  },
};
</script>

<style scoped>
.question-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px 60px;
  min-height: 60vh;
}

/* QUESTION CARD */
.question-card {
  width: 100%;
  max-width: 560px;
  /*  background: rgba(0, 0, 0, 0.45);*/
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 28px 24px;
  margin-bottom: 28px;
}

.question {
  font-family: "VarelaRound", sans-serif;
  font-size: 22px;
  font-weight: bold;
  color: white;
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

/* ANSWERS */
.answers-wrapper {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-bottom: 80px;
}

.answer-btn {
  font-family: "VarelaRound", sans-serif;
  font-size: 17px;
  font-weight: bold;
  color: #2769af;
  background: white;
  border: none;
  border-radius: 50px;
  min-height: 62px;
  width: 100%;
  cursor: pointer;
  transition: transform 80ms linear, box-shadow 80ms linear;
  box-shadow: 0 6px 0 0 #b0bec5, 0 8px 12px rgba(0, 0, 0, 0.35);
  padding: 12px 20px;
  display: block;
}

.answer-btn:active {
  transform: translateY(4px);
  box-shadow: 0 2px 0 0 #b0bec5, 0 2px 6px rgba(0, 0, 0, 0.3);
}

.answer-btn:disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.answer-btn:hover:not(:active) {
  box-shadow: 0 6px 0 0 #90a4ae, 0 10px 16px rgba(0, 0, 0, 0.4);
}

/* JS-managed state classes — must stay globally reachable via querySelectorAll */
.bg-green {
  background: #99bd39 !important;
  color: white !important;
  box-shadow:
    0 0 0 1px #687f27 inset,
    0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 4px 0 0 #687f27,
    0 8px 12px rgba(0, 0, 0, 0.4) !important;
}

.bg-red {
  background: #ff7b7d !important;
  color: white !important;
  box-shadow:
    0 0 0 1px #b6494d inset,
    0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 4px 0 0 #b6494d,
    0 8px 12px rgba(0, 0, 0, 0.4) !important;
}

/* Alias kept for JS class selector compatibility */
.fullWidth {
  width: 100%;
}
</style>
